import { Box, Icon } from '@chakra-ui/react';
import React from 'react';
import data from './data';
import SharedText from './SharedText';
import CenteredFlex from '@components/Shared/CenteredFlex';
import Social from '@components/Shared/Social';

const Information: React.FC = () => {
  return (
    <Box w="100%" pt="110px" px={5} pos="relative" zIndex={0}>
      <CenteredFlex direction="column" maxW="1140px" m="0 auto">
        <Social />
        <Box mb={5}>
          {data.map(({ icon, text }) => (
            <CenteredFlex as="h6" fontSize="lg" mb={2} key={text}>
              <Icon as={() => icon} />
              <SharedText>{text}</SharedText>
            </CenteredFlex>
          ))}
        </Box>
        <Box as="hr" w="15%" h="3px" bg="secondary" />
      </CenteredFlex>
    </Box>
  );
};

export default Information;
